@use "@fukuri-admins/ui/layout" as *;

.root {
  box-sizing: border-box;
  @media (max-width: 1140px) {
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
  @media (max-width: 700px) {
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
  @media (max-width: 540px) {
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}
.mainContainer {
  width: 100%;
}

.form {
  max-width: 400px;
  margin: 0 0 16px;
  text-align: left;
  color: $Text;
  font-size: 16px;
  .formTitle {
    color: $TextInput;
    font-size: 14px;
    margin-bottom: 4px;
    font-weight: 600;
    text-align: left;
    @media (max-width: 440px) {
      font-size: 12px;
    }
  }
}

.formBtn {
  margin-top: 32px;
  @media (max-width: 540px) {
    margin-top: 24px;
    transition-delay: 300ms;
    transition-duration: 1000ms;
  }
}
